import React from 'react';
import ActionsBlock from './components/datatable/ActionsBlock';
import * as DatesUtils from '../../utils/dates';
import { Languages } from '../../config';

const CONFIGURATION = {};

export const allowedActions = {};

export default CONFIGURATION;
//Columns
// message_incoming_id
// ,lxr_ccn_id
// , application_type
// , file_name
// , message_text
// , message_file
// , message_type
// , originating_country
// , destination_country
// , message_id
//     , correlation_id
//     , ccncsi_correlation_id
//     , sent_flag
//     , read_flag
//     , message_ref_id
//     , transmision_date
//     , created_by
//     , created_at
//     , modified_by
//     , modified_at
//table key
export const TableColumns = [
  {
    label: '#',
    id: 'message_incoming_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Message ID',
    id: 'message_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'lxr_ccn_id',
  //   id: 'lxr_ccn_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'application_type',
  //   id: 'application_type',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'File name',
  //   id: 'file_name',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Originating country',
    id: 'originating_country',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Message Type',
    id: 'message_type',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
    ),
    inData: true,
  },

  // {
  //   label: 'Destination Country',
  //   id: 'destination_country',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  // {
  //   label: 'ccncsi_correlation_id',
  //   id: 'ccncsi_correlation_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Status',
    id: 'status',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        <span
          style={{
            color: cellValue === 3 || cellValue === 5 ? 'red' : 'black',
            // fontWeight: data[rowIndex].is_read ? 'normal' : 'bold',
          }}
        >
          {cellValue === 0
            ? 'NOT PROCESSED'
            : cellValue === 1
            ? 'PROCESSED (TEM)'
            : cellValue === 2
            ? 'PROCESSED (OK)'
            : cellValue === 3
            ? 'ERROR (SYSTEM)'
            : cellValue === 5
            ? 'ERROR (MOSS)'
            : cellValue}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'error',
  //   id: 'error',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Sent flag',
  //   id: 'sent_flag',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Read flag',
  //   id: 'read_flag',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'Message Ref ID',
  //   id: 'message_ref_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue ?? 'Not found'}</React.Fragment>
  //   ),
  //   inData: true,
  // },

  {
    label: 'Transmision Date',
    id: 'transmision_date',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Correlation ID',
    id: 'correlation_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'created_by',
  //   id: 'created_by',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'created_at',
  //   id: 'created_at',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'modified_by',
  //   id: 'modified_by',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  // {
  //   label: 'modified_at',
  //   id: 'modified_at',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        rowIndex={rowIndex}
        error={data[rowIndex].error}
        message_incoming_id={data[rowIndex].message_incoming_id}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};

export const Translations = {
  page_title: {
    [Languages.Greek]: 'Message Incoming List',
    [Languages.English]: 'Message Incoming List',
  },
  view_xml: {
    [Languages.Greek]: 'View',
    [Languages.English]: 'View',
  },
  view_error: {
    [Languages.Greek]: 'Error',
    [Languages.English]: 'Error',
  },
  messageId: {
    [Languages.Greek]: 'Message ID',
    [Languages.English]: 'Message ID',
  },
  originatingCountry: {
    [Languages.Greek]: 'Originating Country',
    [Languages.English]: 'Originating Country',
  },
  messageType: {
    [Languages.Greek]: 'Message Type',
    [Languages.English]: 'Message Type',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
};

export const MessageIncomingStatus = [
  {
    id: '0',
    label: 'NOT PROCESSED',
  },
  {
    id: '1',
    label: 'PROCESSED (OK)',
  },
  {
    id: '2',
    label: 'PROCESSED (TEM)',
  },
  {
    id: '3',
    label: 'ERROR (SYSTEM)',
  },
  {
    id: '4',
    label: 'ERROR (MOSS)',
  },
];
